import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintFirstRegistrationHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('PRIMEIRO_EMPLACAMENTO'), config, data, user}, {showUserName: true, breakNewPage: breakNewPage});
}
